<template>
  <b-row>
    <b-col cols="12" class="mb-5">
      <PageTitle title="Editar imagens dos produtos" />
    </b-col>
    <b-col>
      <ProductsFilters
        v-model="filters"
        :externalLoading="loading"
        @search="get()"
        @searchProductsByFamilyId="getValid()"
      />
    </b-col>
    
    <b-col cols="12" class="mt-5 mb-3">
      <b-row class="d-flex align-items-center justify-content-between">
        <b-col>
          <h3 class="title font-weight-bold">Produtos encontrados</h3>
          <span class="text-info">Clique na imagem para visualizar ou alterar</span>
        </b-col>
        
      </b-row>
    </b-col>
    <b-col cols="12">
      <b-table
        striped
        bordered
        hover
        show-empty
        responsive
        fixed
        id="selectProductsTable"
        empty-text="Sem produtos encontrados"
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #cell(photo)="data">
          <span
            @click="$refs.ModalUploadImage.toggleOpen({ 
              photo: data.item, 
            })"
          >
            <img
              :src="linkFotos(data.item.origem) + data.item.produto_fotos[0].foto_png"
              :alt="data.item.produto"
              class="imgWidth"
            />
          </span>
        </template>
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>
        <template #cell(produto)="data">
          <span>
            {{ data.item.produto }}
          </span>
        </template>
      </b-table>
    </b-col>
    <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
        aria-controls="selectProductsTable"
      ></b-pagination>
    </b-col>

    <ModalUploadImage
     ref="ModalUploadImage"
     @newImageProduct="get()"
    />

  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import ProductsFilters from '../../../views/lojista/products/ProductsFilters.vue';
import PageTitle from 'Components/PageTitle.vue';
import ModalUploadImage from 'Components/Admin/uploadImage.vue'
import makeToast from '../../../mixins/makeToast';

export default {
  name: 'SelectProducts',
  mixins: [makeToast],
  components: {
    ProductsFilters,
    PageTitle,
    ModalUploadImage
  },
  data() {
    return {
      loading: false,
      menssageQtd: 1,
      filters: {},
      photoModal: '',
      productModal: '',
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 1,
      },
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'id',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'photo',
            label: 'Fotos',
            sortable: true,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'produto',
            label: 'Produto',
            sortable: true,
          },
          {
            key: 'codbar',
            label: 'Cod. barras',
            sortable: true,
          },
          {
            key: 'marca',
            label: 'Marca',
            sortable: true,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
        ],
        records: [],
      },
    };
  },
  created() {
    this.get();
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  watch: {
    'pagination.currentPage': function () {
      this.get();
    },
  },
  methods: {
    ...mapActions('shopkeeper', [
      'getProducts',
      'getProductsByCategory',
      'getProductsTable',
      'getProductsByFamilyId',
    ]),
    linkFotos(origem) {
      if(origem == 'Belenus') {
        return 'https://storage.googleapis.com/fotos-prd/';
      } else {
        return process.env.VUE_APP_FOTOS_URL;
      }
    },
    deleteFromTable(id) {
      const product = this.table.records.find((x) => x.id === id);
      const index = this.table.records.indexOf(product);
      this.table.records.splice(index, 1);
    },

    get() {
      let marca = "";
      if(this.filters.brand) {
        marca = this.filters.brand.marca
      }else {
        marca = "";
      }
      if (this.loading) return;
      this.loading = true;
      this.table.records = [];

      this.getProductsByFamilyId({
        familyId: this.filters.family || 0,
        currentPage: this.pagination.currentPage,
        productName: this.filters.name,
        userId: this.dadosUsuario.id,
        brand: marca
      })
        .then((response) => {
          const { per_page, total, data } = response.data.data || {};
          this.pagination.itemsPerPage = per_page || 15;
          this.pagination.total = total || 15;
          this.$set(this.table, 'records', data || []);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getValid() {
      this.table.records = [];
      this.pagination.currentPage = 1;
      this.get();
    },
  },
};
</script>

<style scoped>
.imgWidth {
  width: 50px;
  cursor: pointer;
}
</style>
